export default "__VITE_ASSET__h_cr5eg2__"